import { render } from "./base-form.vue?vue&type=template&id=d4e9c820&scoped=true"
import script from "./base-form.vue?vue&type=script&lang=js"
export * from "./base-form.vue?vue&type=script&lang=js"

import "./base-form.vue?vue&type=style&index=0&id=d4e9c820&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e9c820"]])

export default __exports__